import React, { Component, Fragment } from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import ChartCard from './components/cards/ChartCard';
import moment from 'moment';
import {
  postAPI_TrackEvent,
  gAPI_Invitation_By_Email,
  gAPI_Users_By_Id,
  gAPI_Check_Invitation,
} from '../../../constants/APIs';
import { AxiosAPI, getGroupID, getUserID } from '../../../helpers/AxiosAPI';
import ReviewVoucher from './components/ReviewVoucher';
class DashboardAnalytics extends Component {
  constructor(props) {
    super(props);
    this.state = {
      vouchers: [],
      reviewVoucher: false,
    };
  }
  componentDidMount() {
    try {
      var time = localStorage.getItem('time');
      var val = false;
      if (time === null) val = true;
      else {
        var date1 = new Date(time);
        var date2 = new Date();
        var Difference_In_Time = date2.getTime() - date1.getTime();
        var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
        if (parseInt(Difference_In_Days) === 1) {
          val = true;
        }
      }
      if (val == true) {
        AxiosAPI({
          method: 'get',
          url: `${gAPI_Users_By_Id}/${getUserID()}?gid=${getGroupID()}`,
        }).then((res) => {
          //console.log(res.data);
          AxiosAPI({
            methhod: 'get',
            url: `${gAPI_Check_Invitation}?email=${res.data.email}`,
          })
            .then((res) => {
              console.log(res.data);
              if (res.data.status === 'Pending') {
                this.setState({ reviewVoucher: true });
                localStorage.setItem('time', new Date());
              }
            })
            .catch((err) => null);
        });
      }
    } catch { }
    try {
      if (this.state.invitation !== '') {
        AxiosAPI({
          url: `${gAPI_Invitation_By_Email}?id=${getUserID()}&group_id=${getGroupID()}&property_id=${this.props.propertyId
            }`,
          mehthod: 'get',
        })
          .then((res) => {
            res.data.map((m) => {
              if (m.invitationId === this.state.invitation) {
                window.location.href = '/app/pages/vouchers';
              }
            });
          })
          .catch((err) => console.log(err));
        // });
        // }
        // });
      }
    } catch { }
    if (this.props.email !== '') {
      AxiosAPI({
        method: 'post',
        url: `${postAPI_TrackEvent} `,
        data: {
          eventName: 'aiva Insights',
          email: this.props.email,
        },
      }).then(
        (res) => { },
        (error) => {
          console.log(error);
        }
      );
    }
  }
  render() {
    const { messages } = this.props.intl;
    return (
      <Fragment>
        <ChartCard
          propertyId={this.props.propertyId}
          timeZone={this.props.timeZone}
          domains={this.props.domains}
          isVoucherEngine={this.props.isVoucherEngine}
          currency={this.props.currency}
          history={this.props.history}
        />
        {this.state.reviewVoucher !== undefined && this.state.reviewVoucher && (
          <ReviewVoucher
            visible={this.state.reviewVoucher}
            hideModal={() => {
              this.setState({ reviewVoucher: !this.state.reviewVoucher });
            }}
          ></ReviewVoucher>
        )}
        {/* <Row> */}
        {/* <Colxx xl="4" lg="6" md="12" className="mb-4"> */}
        {/* <ProductCategoriesDoughnut /> */}
        {/* </Colxx>
          <Colxx xl="4" lg="6" md="12" className="mb-4"> */}
        {/* <ProfileStatuses cardClass="dashboard-progress" /> */}
        {/* </Colxx>
          <Colxx xl="4" lg="12" md="12">
            <SmallLineCharts itemClass="dashboard-small-chart-analytics" />
          </Colxx>
        </Row>

        <SortableStaticticsRow messages={messages} />

        <Row>
          <Colxx xxs="12" lg="6" className="mb-4">
            <OrderStockRadarChart />
          </Colxx>
          <Colxx xxs="12" lg="6" className="mb-4">
            <ProductCategoriesPolarArea />
          </Colxx>
        </Row>

        <Row>
          <Colxx xxs="12" className="mb-4">
            <SalesChartCard />
          </Colxx>
        </Row> */}
      </Fragment>
    );
  }
}

const mapStateToProps = ({ authUser, settings, oidc }) => {
  const { user: loginUser } = authUser;
  const {
    locale,
    propertyId,
    isVoucherEngine,
    timeZone,
    email,
    domains,
    currency,
  } = settings;
  //console.log(settings);
  return {
    loginUser,
    locale,
    oidc,
    isVoucherEngine,
    propertyId,
    timeZone,
    email,
    domains,
    currency,
  };
};

const mapActionsToProps = {};

const aap = injectIntl(DashboardAnalytics);
export default connect(mapStateToProps, mapActionsToProps)(aap);
